import {Command} from "../decorators/command.decorator";
import {Project} from "../domain/entities/project.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/**
 * Command to delete a project entity.
 * Accepts the full entity; the transformer extracts the UID for the backend payload.
 */
@Command({type: 'delete', prototype: Project})
export class DeleteProjectCommand extends AbstractCommand<Project> {

    public name: CommandName = CommandName.DELETE_PROJECT;

    public tags = ['entity', 'delete', 'project'];

    constructor(payload: Project) {
        super('project', payload.uid, payload);
    }
}
